import { QuestionTooltip } from '@snack-uikit/tooltip';
import styles from "./styles.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
export function Tooltip(_ref) {
  var tip = _ref.tip,
    appearance = _ref.appearance;
  return /*#__PURE__*/_jsx(QuestionTooltip, {
    "data-color": "blue",
    className: styles.tooltip,
    size: "xs",
    tip: tip,
    trigger: "hover",
    triggerSupportProps: {
      'data-appearance': appearance,
      'data-test-id': 'tag__tooltip'
    }
  });
}